import React, { useState } from 'react';
import { useClickOutside, useDisclosure } from '@mantine/hooks';
import { Popover, PopoverProps } from '../Popover/Popover';
import { Container } from './HoverPopover.styles';

export interface HoverPopoverProps extends PopoverProps {
  clickBody?: React.ReactNode;
  className?: string;
}

export default function HoverPopover({
  body,
  children,
  position = 'top',
  clickBody,
  className,
  ...rest
}: HoverPopoverProps) {
  const [opened, { open, close }] = useDisclosure();
  const [clicked, setClicked] = useState(false);

  const handleClick = () => {
    if (clickBody) {
      setClicked(true);
      open();
    }
  };

  const handleMouseEnter = () => {
    if (!clicked) {
      open();
    }
  };

  const handleMouseLeave = () => {
    if (!clicked) {
      close();
    }
  };

  const handlePopoverClose = () => {
    close();
    setTimeout(() => {
      setClicked(false);
    }, 100);
  };

  const clickOutsideRef = useClickOutside(handlePopoverClose);

  return (
    <Popover
      body={clicked ? clickBody : body}
      opened={opened}
      position={position}
      onClose={handlePopoverClose}
      {...rest}
    >
      <Container
        className={className}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={handleClick}
        ref={clickOutsideRef}
      >
        {children}
      </Container>
    </Popover>
  );
}
